<template>
    <div>
       <router-view></router-view>
    </div>
</template>


<script>
export default {
    name: "router_page",
    components:{
      
    },
    data() {
        return {
            
        }
    },
    mounted:function(){
       
    }
}
</script>